module.exports = __webpack_public_path__ + "static/media/temp-video-thumbnail.491c7acc.png";